import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'act-dialog-cancellation',
  templateUrl: './dialog-cancellation.component.html',
  styleUrls: ['./dialog-cancellation.component.scss']
})
export class DialogCancellationComponent implements OnInit {

  public cancellations: String[];

  constructor(public dialogRef: MdDialogRef<DialogCancellationComponent>) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-cancellation/dialog-cancellation.component.ts